import React, { type FC, type JSX } from 'react';
import { IconCheckSolid } from '@/app/common/icons/libraryIcons';
import { useTranslation } from '@/app/components/translations/Translation';
import {
  AirportPopupDescStyled,
  AirportPopupIataStyled,
  AirportPopupNameStyled,
  AirportPopupNotSelectedStyled,
  AirportPopupSelectedLabelStyled,
  AirportPopupSelectedStyled,
  AirportPopupStyled,
} from './styled';

export type HandleAirportClicked = (iata: string) => void;

export type AirportPopupProps = {
  iata: string;
  name: string;
  selected: boolean;
  multiAirportsSelected: boolean;
  handleAirportClicked: HandleAirportClicked;
  isStation: boolean;
};

const AirportPopup: FC<AirportPopupProps> = ({
  iata,
  name,
  selected,
  multiAirportsSelected,
  handleAirportClicked,
  isStation,
}): JSX.Element => {
  const { t } = useTranslation();
  let desc = isStation ? t('vacation.oss.map.select_station_desc') : t('vacation.oss.map.select_airport_desc');
  const selectedDesc = isStation
    ? t('vacation.oss.map.selected_station_desc')
    : t('vacation.oss.map.selected_airport_desc');

  if (selected) {
    desc = multiAirportsSelected ? t('vacation.oss.map.selected_airport_desc_relevant') : selectedDesc;
  }

  const handleOnClick = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    handleAirportClicked(iata);
  };

  const createSelectedComponent = () => {
    if (multiAirportsSelected) return null;

    return selected ? (
      <AirportPopupSelectedStyled>
        <IconCheckSolid size="14" />
        <AirportPopupSelectedLabelStyled>
          {isStation ? t('vacation.oss.map.selected_station') : t('vacation.oss.map.selected_airport')}
        </AirportPopupSelectedLabelStyled>
      </AirportPopupSelectedStyled>
    ) : (
      <AirportPopupNotSelectedStyled onClick={handleOnClick}>
        {isStation ? t('vacation.oss.map.select_station') : t('vacation.oss.map.select_airport')}
      </AirportPopupNotSelectedStyled>
    );
  };

  return (
    <AirportPopupStyled>
      <AirportPopupIataStyled>{iata}</AirportPopupIataStyled>
      <AirportPopupNameStyled>{name}</AirportPopupNameStyled>
      {createSelectedComponent()}
      <AirportPopupDescStyled>{desc}</AirportPopupDescStyled>
    </AirportPopupStyled>
  );
};

export default AirportPopup;
